import { useTranslation } from "@i18n/hooks";

export const NoAccess = () => {
	const { t } = useTranslation("common");

	return <>{t("errors.noAccess")}</>;
};
